import { useEffect, useState } from "react";
import { socketClient } from "../socket/socketClient";
import { onConnect, onDisconnect } from "../socket/listeners";

export const useSocket = () => {
  const [isConnected, setIsConnected] = useState(socketClient.isConnected());

  useEffect(() => {
    setIsConnected(socketClient.isConnected());

    const cleanupConnect = onConnect(() => setIsConnected(true));
    const cleanupDisconnect = onDisconnect(() => setIsConnected(false));

    return () => {
      cleanupConnect();
      cleanupDisconnect();
    };
  }, []);

  return {
    socket: socketClient,
    isConnected,
    connect: (token: string) => socketClient.connect(token),
    disconnect: () => socketClient.disconnect(),
  };
};

export default useSocket;
